import { html, when } from '@microsoft/fast-element';
import { ProjectMetrics } from './project-metrics';
import { sync } from '@genesislcap/foundation-utils';
import { AVERAGE_TYPE, PRODUCT_TYPE } from '../../../../../utils';

export const ProjectMetricsTemplate = html<ProjectMetrics>`
  <div class="quantiles-card">
    <div class="header-wrapper">
      <div class="header">Key Metric Quintiles</div>
      <div class="right-side">
        <zero-segmented-control
          appearance="primary"
          orientation="horizontal"
          :value="${sync((x) => x.averageTypeValue)}"
        >
          <zero-segmented-item value=${AVERAGE_TYPE?.ALL_ISOS}>All ISOs</zero-segmented-item>
          <zero-segmented-item value=${AVERAGE_TYPE?.SINGLE_ISO}>Single ISO</zero-segmented-item>
        </zero-segmented-control>
      </div>
    </div>
    ${when(
      (x) => x.selectedProductType !== PRODUCT_TYPE.RECS,
      html<ProjectMetrics>`
        <div class="section">
          <div class="section-header">Financial Metrics</div>
          <metrics-tile :vppaMetrics=${(x) => x.financialMetrics}></metrics-tile>
        </div>
      `
    )}

    <div class="section">
      <div class="section-header">Carbon Metrics</div>
          <metrics-tile :vppaMetrics=${(x) => x.carbonMetrics}></metrics-tile>
    </div>
    <div class="disclaimer-div">
       <span class="disclaimer">
            Negative Pricing Methods are not factored into Key Metric calculations.
       </span>
    </div>
    <div class="footer">
      Metrics powered by
      <div class="resurety-logo"></div>
    </div>
  </div>
`;
